// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/profile/v1/search.proto (package gdx.gateway.web.profile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { BoolValue, Message, proto3 } from "@bufbuild/protobuf";
import { ProfileBodyType, ProfileChildren, ProfileComfortRadiusUnits, ProfileDrinking, ProfileEducation, ProfileEthnicity, ProfileEyeColor, ProfileGender, ProfileHairColor, ProfileHeight, ProfileLocation, ProfileLookingFor, ProfileMaritalStatus, ProfilePhoto, ProfileReligion, ProfileSexualOrientation, ProfileSmoking, ProfileSphereOfWork, ProfileSport } from "./profile_pb.js";

/**
 * Describes allowed criteria for profile search.
 *
 * @generated from message gdx.gateway.web.profile.v1.SearchCriteria
 */
export class SearchCriteria extends Message<SearchCriteria> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 1;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: uint32 age_from = 2;
   */
  ageFrom = 0;

  /**
   * @generated from field: uint32 age_to = 3;
   */
  ageTo = 0;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.SearchLocation location = 4;
   */
  location?: SearchLocation;

  /**
   * @generated from field: bool is_new = 6;
   */
  isNew = false;

  /**
   * @generated from field: bool is_online = 7;
   */
  isOnline = false;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSmoking smoking = 8;
   */
  smoking: ProfileSmoking[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileDrinking drinking = 9;
   */
  drinking: ProfileDrinking[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileMaritalStatus marital_status = 10;
   */
  maritalStatus: ProfileMaritalStatus[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileChildren children = 11;
   */
  children: ProfileChildren[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSexualOrientation sexual_orientation = 13;
   */
  sexualOrientation: ProfileSexualOrientation[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileReligion religion = 14;
   */
  religion: ProfileReligion[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEthnicity ethnicity = 15;
   */
  ethnicity: ProfileEthnicity[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileBodyType body_type = 16;
   */
  bodyType: ProfileBodyType[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileHairColor hair_color = 17;
   */
  hairColor: ProfileHairColor[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileLookingFor looking_for = 18;
   */
  lookingFor: ProfileLookingFor[] = [];

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileHeight height_from = 19;
   */
  heightFrom?: ProfileHeight;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileHeight height_to = 20;
   */
  heightTo?: ProfileHeight;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSport sport = 23;
   */
  sport: ProfileSport[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEducation education = 24;
   */
  education: ProfileEducation[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileEyeColor eye_color = 25;
   */
  eyeColor: ProfileEyeColor[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfileSphereOfWork sphere_of_work = 26;
   */
  sphereOfWork: ProfileSphereOfWork[] = [];

  /**
   * @generated from field: repeated string interests = 27;
   */
  interests: string[] = [];

  /**
   * @generated from field: google.protobuf.BoolValue has_photos = 28;
   */
  hasPhotos?: boolean;

  constructor(data?: PartialMessage<SearchCriteria>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchCriteria";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 2, name: "age_from", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "age_to", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "location", kind: "message", T: SearchLocation },
    { no: 6, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "smoking", kind: "enum", T: proto3.getEnumType(ProfileSmoking), repeated: true },
    { no: 9, name: "drinking", kind: "enum", T: proto3.getEnumType(ProfileDrinking), repeated: true },
    { no: 10, name: "marital_status", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus), repeated: true },
    { no: 11, name: "children", kind: "enum", T: proto3.getEnumType(ProfileChildren), repeated: true },
    { no: 13, name: "sexual_orientation", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation), repeated: true },
    { no: 14, name: "religion", kind: "enum", T: proto3.getEnumType(ProfileReligion), repeated: true },
    { no: 15, name: "ethnicity", kind: "enum", T: proto3.getEnumType(ProfileEthnicity), repeated: true },
    { no: 16, name: "body_type", kind: "enum", T: proto3.getEnumType(ProfileBodyType), repeated: true },
    { no: 17, name: "hair_color", kind: "enum", T: proto3.getEnumType(ProfileHairColor), repeated: true },
    { no: 18, name: "looking_for", kind: "enum", T: proto3.getEnumType(ProfileLookingFor), repeated: true },
    { no: 19, name: "height_from", kind: "message", T: ProfileHeight },
    { no: 20, name: "height_to", kind: "message", T: ProfileHeight },
    { no: 23, name: "sport", kind: "enum", T: proto3.getEnumType(ProfileSport), repeated: true },
    { no: 24, name: "education", kind: "enum", T: proto3.getEnumType(ProfileEducation), repeated: true },
    { no: 25, name: "eye_color", kind: "enum", T: proto3.getEnumType(ProfileEyeColor), repeated: true },
    { no: 26, name: "sphere_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork), repeated: true },
    { no: 27, name: "interests", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 28, name: "has_photos", kind: "message", T: BoolValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchCriteria {
    return new SearchCriteria().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchCriteria {
    return new SearchCriteria().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchCriteria {
    return new SearchCriteria().fromJsonString(jsonString, options);
  }

  static equals(a: SearchCriteria | PlainMessage<SearchCriteria> | undefined, b: SearchCriteria | PlainMessage<SearchCriteria> | undefined): boolean {
    return proto3.util.equals(SearchCriteria, a, b);
  }
}

/**
 * Describes profile returned by search method.
 *
 * @generated from message gdx.gateway.web.profile.v1.SearchProfile
 */
export class SearchProfile extends Message<SearchProfile> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 3;
   */
  age = 0;

  /**
   * @generated from field: float distance = 4;
   */
  distance = 0;

  /**
   * @generated from field: string location_name = 5;
   */
  locationName = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 6;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: bool is_new = 7;
   */
  isNew = false;

  /**
   * @generated from field: bool is_verified = 8;
   */
  isVerified = false;

  /**
   * @generated from field: bool is_online = 9;
   */
  isOnline = false;

  /**
   * @generated from field: bool is_highlighted = 10;
   */
  isHighlighted = false;

  /**
   * @generated from field: string search_position = 11;
   */
  searchPosition = "";

  /**
   * @generated from field: bool is_liked = 12;
   */
  isLiked = false;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 13;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.ProfilePhoto photos = 14;
   */
  photos: ProfilePhoto[] = [];

  /**
   * @generated from field: string card_id = 15;
   */
  cardId = "";

  constructor(data?: PartialMessage<SearchProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "distance", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 7, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_highlighted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "search_position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "is_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "location", kind: "message", T: ProfileLocation },
    { no: 14, name: "photos", kind: "message", T: ProfilePhoto, repeated: true },
    { no: 15, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchProfile {
    return new SearchProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchProfile {
    return new SearchProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchProfile {
    return new SearchProfile().fromJsonString(jsonString, options);
  }

  static equals(a: SearchProfile | PlainMessage<SearchProfile> | undefined, b: SearchProfile | PlainMessage<SearchProfile> | undefined): boolean {
    return proto3.util.equals(SearchProfile, a, b);
  }
}

/**
 * Describes location and radius during profile search.
 *
 * @generated from message gdx.gateway.web.profile.v1.SearchLocation
 */
export class SearchLocation extends Message<SearchLocation> {
  /**
   * @generated from field: uint32 radius = 3;
   */
  radius = 0;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileComfortRadiusUnits radius_units = 4;
   */
  radiusUnits = ProfileComfortRadiusUnits.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileLocation location = 5;
   */
  location?: ProfileLocation;

  constructor(data?: PartialMessage<SearchLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "radius", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "radius_units", kind: "enum", T: proto3.getEnumType(ProfileComfortRadiusUnits) },
    { no: 5, name: "location", kind: "message", T: ProfileLocation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchLocation {
    return new SearchLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchLocation {
    return new SearchLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchLocation {
    return new SearchLocation().fromJsonString(jsonString, options);
  }

  static equals(a: SearchLocation | PlainMessage<SearchLocation> | undefined, b: SearchLocation | PlainMessage<SearchLocation> | undefined): boolean {
    return proto3.util.equals(SearchLocation, a, b);
  }
}

/**
 * Describes search profile meta data.
 *
 * @generated from message gdx.gateway.web.profile.v1.SearchMeta
 */
export class SearchMeta extends Message<SearchMeta> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string location_name = 3;
   */
  locationName = "";

  /**
   * @generated from field: float distance = 4;
   */
  distance = 0;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[] = [];

  /**
   * @generated from field: bool is_online = 6;
   */
  isOnline = false;

  /**
   * @generated from field: int32 age_diff = 7;
   */
  ageDiff = 0;

  constructor(data?: PartialMessage<SearchMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.profile.v1.SearchMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "distance", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "age_diff", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchMeta {
    return new SearchMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchMeta {
    return new SearchMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchMeta {
    return new SearchMeta().fromJsonString(jsonString, options);
  }

  static equals(a: SearchMeta | PlainMessage<SearchMeta> | undefined, b: SearchMeta | PlainMessage<SearchMeta> | undefined): boolean {
    return proto3.util.equals(SearchMeta, a, b);
  }
}

